import { ActionContext } from 'vuex'
import apiAdminPositionRemarquable from '@/api/admin/positionRemarquable'
import util from '@/utils/classToObject'
import types from '@/store/all-mutation-types'
import { IRootState } from '@/store'
import { IPositionRemarquableState } from './state'
import { ApiResultCode } from '@/models/response/AlrBase'
import { AloPositionRemarquable } from '@/models/alo/AloPositionRemarquable'
import { AloError } from '@/models/alo/AloError'
import { AloBaseArray } from '@/models/alo/AloBaseArray'
import { router } from '@/mainjs.js'
import {i18n} from '@/locale/vueI18n'

export class PositionRemarquableAction {
  public [types.POSITIONREMARQUABLE_REQUEST](context: ActionContext<IPositionRemarquableState, IRootState>) {
    return new Promise((resolve, reject) => {
      context.commit(types.POSITIONREMARQUABLE_REQUEST)
      apiAdminPositionRemarquable
        .getPositionRemarquables()
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const positionRemarquableArray = resp.data.data as AloBaseArray<AloPositionRemarquable>
            context.commit(types.POSITIONREMARQUABLE_SUCCESS, positionRemarquableArray.items)
            resolve(positionRemarquableArray.items)
          } else {
            context.commit(types.POSITIONREMARQUABLE_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(resp => {
          context.commit(types.POSITIONREMARQUABLE_ERROR)
          reject()
        })
    })
  }

  public [types.POSITIONREMARQUABLE_ENSURE_LIST](context: ActionContext<IPositionRemarquableState, IRootState>) {
    if (context.state.positionRemarquables.length == 0) {
      return context.dispatch(types.POSITIONREMARQUABLE_REQUEST)
    } else {
      return new Promise((resolve, reject) => {
        resolve(context.state.positionRemarquables)
      })
    }
  }

  public [types.POSITIONREMARQUABLE_SELECT_DETAIL](context: ActionContext<IPositionRemarquableState, IRootState>, itemId: number) {
    return new Promise((resolve, reject) => {
      const positionRemarquable = context.getters.positionRemarquablesById[itemId] as AloPositionRemarquable
      if (positionRemarquable) {
        if (positionRemarquable.detailLoaded) {
          context.commit(types.POSITIONREMARQUABLE_SELECT_DETAIL, positionRemarquable)
          resolve(positionRemarquable)
        } else {
          context.dispatch(types.POSITIONREMARQUABLE_SELECT_DETAIL_REQUEST, itemId).then(ens => {
            context.commit(types.POSITIONREMARQUABLE_SELECT_DETAIL, ens)
            resolve(ens)
          })
        }
      } else {
        const newpositionRemarquable = new AloPositionRemarquable()
        context.commit(types.POSITIONREMARQUABLE_SELECT_DETAIL, newpositionRemarquable)
        resolve(newpositionRemarquable)
      }
    })
  }

  public [types.POSITIONREMARQUABLE_SELECT_DETAIL_REQUEST](context: ActionContext<IPositionRemarquableState, IRootState>, itemId: number) {
    return new Promise((resolve, reject) => {
      context.commit(types.POSITIONREMARQUABLE_SELECT_DETAIL_REQUEST, itemId)
      apiAdminPositionRemarquable
        .getPositionRemarquable(itemId)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const positionRemarquable = resp.data.data as AloPositionRemarquable
            context.commit(types.POSITIONREMARQUABLE_SELECT_DETAIL_SUCCESS, positionRemarquable)
            context.commit(types.POSITIONREMARQUABLE_SELECT_DETAIL, positionRemarquable)
            resolve(positionRemarquable)
          } else {
            context.commit(types.POSITIONREMARQUABLE_SELECT_DETAIL_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(() => {
          context.commit(types.POSITIONREMARQUABLE_SELECT_DETAIL_ERROR)
          reject()
        })
    })
  }

  public [types.POSITIONREMARQUABLE_SAVE_REQUEST](context: ActionContext<IPositionRemarquableState, IRootState>) {
    return new Promise((resolve, reject) => {
      const tryRedirect = !context.state.modifiedAdmPositionRemarquable.id
      context.commit(types.POSITIONREMARQUABLE_SAVE_REQUEST, context.state.modifiedAdmPositionRemarquable.prmLibelle)
      apiAdminPositionRemarquable
        .savePositionRemarquable(context.state.modifiedAdmPositionRemarquable)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            const positionRemarquable = resp.data.data as AloPositionRemarquable
            context.commit(types.POSITIONREMARQUABLE_SELECT_DETAIL_SUCCESS, positionRemarquable)
            context.commit(types.POSITIONREMARQUABLE_SELECT_DETAIL, positionRemarquable)
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.SaveOk',{item:positionRemarquable.prmLibelle}))                      
            if (tryRedirect && router.app.$route.name === 'NewPositionRemarquable')
              router.push({ name: 'EditPositionRemarquable', params: { itemid: positionRemarquable.id!.toString() } })
            resolve(positionRemarquable)
          } else {
            console.error('ATTENTION une reponse Code 200 contient une erreur')
            context.commit(types.POSITIONREMARQUABLE_SAVE_ERROR)
            const error = resp.data.data as AloError
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:error.errorMessage}))
            console.error(error)
            reject(error)
          }
        })
        .catch(error => {
          context.commit(types.POSITIONREMARQUABLE_SAVE_ERROR)
          if (error.response) {
            const er = error.response.data.data as AloError
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:er.errorMessage}))
            console.error(er)
            reject(er)
          } else {
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorOnSave'))
            reject()
          }
        })
    })
  }

  public [types.POSITIONREMARQUABLE_UPDATE_MODIFIED_ADM](
    context: ActionContext<IPositionRemarquableState, IRootState>,
    newProperties: Object
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.POSITIONREMARQUABLE_UPDATE_MODIFIED_ADM, newProperties)
      resolve(context.state.modifiedAdmPositionRemarquable)
    })
  }

  public [types.POSITIONREMARQUABLE_CANCEL_MODIFIED_ADM](context: ActionContext<IPositionRemarquableState, IRootState>) {
    return new Promise((resolve, reject) => {
      context.commit(types.POSITIONREMARQUABLE_SELECT_DETAIL, context.state.originalAdmPositionRemarquable)
      resolve(context.state.modifiedAdmPositionRemarquable)
    })
  }

  public [types.POSITIONREMARQUABLE_UPDATE_FILTER_ADM](context: ActionContext<IPositionRemarquableState, IRootState>, newProperties:Object) {        
    return new Promise((resolve, reject) => {
      context.commit(types.POSITIONREMARQUABLE_UPDATE_FILTER_ADM,newProperties)
      resolve(context.state.adminFilter)
    })
  }
}

export default util.classToObject(PositionRemarquableAction)
